import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from "antd";
import { getProductionLinesWithPage } from "../../services/serviceProductionLine";
import ProductionLineCreate from "./ProductionCreate";
import ProductionLineActions from "./ProductionActions";

const ProductionLine = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getProductionLines(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getProductionLines = (page, pageSize) => {
        getProductionLinesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getProductionLines(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    productionName: item.name,
                    productionCode: item.code,
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }


    const columns = [
        {
            title: 'Üretim Hattı Adı',
            dataIndex: 'productionName',
            key: 'productionName'
        },
        {
            title: 'Üretim Hattı Kodu',
            dataIndex: 'productionCode',
            key: 'productionCode'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <ProductionLineActions record={record} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card title={'Üretim Hattı Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <ProductionLineCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default ProductionLine